import React, { Fragment, useState } from 'react'

import { Header, Footer, Search, CookieBanner } from '@moonpig/launchpad-nav'
import { GlobalStyle, Container } from '@moonpig/launchpad-components'
import { theme } from '@moonpig/launchpad-theme'
import { ThemeProvider } from 'styled-components'
import { FlagUk, FlagUs, FlagAu } from '@moonpig/launchpad-assets'

import { navItems } from './navItems'
import { CardsIndexPage } from './FakeLandingPage'

const StyledWrapper = ({ children }) => (
  <ThemeProvider theme={theme}>
    <Fragment>
      <GlobalStyle />
      {children}
    </Fragment>
  </ThemeProvider>
)

const CookieBannerWrapper = () => {
  const [showCookieBanner, setShowCookieBanner] = useState(true)
  return showCookieBanner && <CookieBanner onCloseClick={() => setShowCookieBanner(false)} />
}

const App = () => (
  <StyledWrapper>
    <Header navItems={navItems} logo={{ to: '/' }}><Search /></Header>
    <Container limitWidth>
      <CardsIndexPage />
    </Container>
    <CookieBannerWrapper />
    <Footer
      regions={[
        {
          component: FlagUk,
          linkHref: '/uk',
          shortLabel: 'UK',
          label: 'United Kingdom',
          current: true,
        },
        {
          component: FlagUs,
          linkHref: '/us',
          shortLabel: 'US',
          label: 'United States of America',
          current: false,
        },
        {
          component: FlagAu,
          linkHref: '/au',
          shortLabel: 'AUS',
          label: 'Australia',
          current: false,
        },
      ]}
    />
  </StyledWrapper>
)

export default App
